<template>
  <b-col v-show="isVisible" v-if="!toolTipClosed" md="12" lg="12">
    <div :class="mainCSSClass" :style="`border-color: ${color};`" ref="tooltip">
      <div class="custom_tooltip-main_container">
        <div :style="`background-color: ${color}`" class="custom_tooltip-icon_wrapper">
          <!-- <img :src="icon" alt="Tooltip Icon" class="custom_tooltip-icon" /> -->
          <div class="custom_tooltip-icon">🔥</div>
        </div>
        <p class="fs14 px-16 py-16">
          <slot></slot>
        </p>
      </div>
      <button v-if="closable" class="close-icon py-20 px-20" @click="hideTooltip"></button>
    </div>
  </b-col>
</template>

<script>
import Container from '@/components/Container.vue';
export default {
  name: 'Tooltip',
  components: {
    Container
  },
  props: {
    content: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: '#443fdb'
    },
    icon: {
      type: String,
      required: false,
      default: require('@/assets/components/plans/info.svg')
    },
    closable: {
      type: Boolean,
      required: false,
      default: false
    },
    source: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      toolTipClosed: false,
      targetId: 'thehub_footer',
      isVisible: true,
      targetResizeId: 'thehub_plans'
    };
  },
  mounted() {
    this.createObserver();
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    window.removeEventListener('resize', this.updateDimensions);
  },
  methods: {
    updateDimensions() {
      const target = document.getElementById(this.targetResizeId);

      if (!target || this.source !== 'monetise') {
        return;
      }

      const fixedComponent = this.$refs.tooltip;
      const targetRect = target.getBoundingClientRect();

      if (fixedComponent) {
        fixedComponent.style.width = `${targetRect.width + 1}px`;
        fixedComponent.style.left = `${targetRect.left}px`;
      }
    },
    getParsedContent() {
      return this.content;
    },
    hideTooltip() {
      this.toolTipClosed = true;
    },
    createObserver() {
      const targetElement = document.getElementById(this.targetId);
      if (!targetElement) {
        return;
      }

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.isVisible = !entry.isIntersecting;
        },
        {
          threshold: 0.1
        }
      );
      this.observer.observe(targetElement);
    }
  },
  computed: {
    mainCSSClass() {
      if (this.source === 'monetise') return 'custom_tooltip-monetise mb-24';
      return 'custom_tooltip-default mb-24';
    }
  }
};
</script>

<style scoped lang="scss">
.custom_tooltip-default {
  position: fixed;

  z-index: 99;
  // bottom: 75px;
  bottom: 6rem;
  left: 0px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  border: 1px solid;
  left: 17.5rem;
  @media (min-width: 1350px) {
    // width: calc(100% - 18.2rem);
    // width: calc(100% - 34.2rem);
    width: calc(100% - 37rem);
    // width: calc(100% - 2rem);
  }

  @media (min-width: 767px) and (max-width: 1350px) {
    // width: calc(100% - 18.2rem);
    // width: calc(100% - 1px);
    width: calc(100% - 19rem);
    left: 17.5rem;
  }

  @media (max-width: 767px) {
    // width: calc(100% - 18.2rem);
    // width: calc(100% - 1px);
    width: calc(100% - 2rem);
    left: 1rem;
  }
  //   @include media-breakpoint-down(1360px) {

  //   }
}
.custom_tooltip-monetise {
  position: fixed;
  // width: calc(100% - 4rem);
  z-index: 99;
  bottom: 4rem;
  // left: 2rem;
  // width: -webkit-fill-available;
  // width: -moz-available;
  // width: fill-available;

  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  border: 1px solid;
}

.custom_tooltip-icon_wrapper {
  width: 2.5rem;
  min-width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom_tooltip-icon {
  padding-top: 3px;
  width: 1.3rem;
  height: 1.3rem;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.custom_tooltip-main_container {
  display: flex;
}

.close-icon {
  margin-left: 8px;
  text-decoration: none;
  float: none;
  text-shadow: none;
  opacity: 1;
  font-size: 0;
  @include icon('e912');

  &:before {
    color: $gray-900;
    cursor: pointer;
    text-decoration: none;
    font-size: rem(9px);
    @include transition();
  }

  &:hover,
  &:active,
  &:focus {
    &:before {
      color: $blue-800;
      text-decoration: none;
    }
  }
}
</style>
